import { module } from "angular";
import { ProfileService } from "./ProfileService";

module("mmAuth").service("mmProfileService", ProfileService);
